module.exports = __webpack_public_path__ + "img/4x.93dffe01.png";